<template>
  <div id="data-view">
    <dv-full-screen-container>

      <top-header />

      <div class="main-content">
        <digital-flop />

        <div class="block-left-right-content">
          <ranking-board   />

          <div class="block-top-bottom-content">
            <div class="block-top-content">
              <rose-chart />

              <water-level-chart />

              <scroll-board />
            </div>

            <cards />
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from '@/components/datav/topHeader'
import digitalFlop from '@/components/datav/digitalFlop'
import rankingBoard from '@/components/datav/rankingBoard'
import roseChart from '@/components/datav/roseChart'
import waterLevelChart from '@/components/datav/waterLevelChart'
import scrollBoard from '@/components/datav/scrollBoard'
import cards from '@/components/datav/cards'
import {mapGetters} from "vuex";
import {getToken} from "@/utils/auth";
import {Screen} from "@/api/screen";

export default {
  name: 'DataView',
  components: {
    topHeader,
    digitalFlop,
    rankingBoard,
    roseChart,
    waterLevelChart,
    scrollBoard,
    cards
  },
  computed: {...mapGetters(['titleList','rankingList'])},
  data () {
    return {
      objs:{},
      objs2:{},

      titleData:{tCaseCnt:0,tInCallCnt:0,tOutCallCnt:0,tCallLen:0,tMailCnt:0,mCaseCnt:0,mInCallCnt:0,mOutCallCnt:0,InvestCnt:0,InvestOkCnt:0},
    }
  },
  async mounted() {
    // console.log('do 0')
    // this.aa = ({n:6})
    // console.log('this.$store',this.$store)
    // await this.$store.dispatch('screen/screenSet',{}).then(Response=>{
    //   // console.log('this.rankingList',this.rankingList)
    //   if (this.titleList[0]){
    //     this.titleData = this.titleList[0];        
    //   }
    // });
    // const {data} = await Screen({userId: getToken()});
    // this.objs2=data;
		// this.objs = this.$store.dispatch('getNumObj');
		// console.log('do 3')
	},
  
  methods: {}
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('../../images/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }

  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
    width: 80%;
  }

  .block-top-content {
    height: 55%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
}
</style>
